import { User } from '@core/auth/hooks/use-profile/use-profile.hook.types'

import { UserPermission } from '../user-permissions/user-permissions.types'

export const getUserPermission = (user?: User) => {
  if (!user) return undefined

  const userPermissions = user?.permissions ?? []
  const permissionsArray = Object.values(UserPermission)

  const permission = permissionsArray.find((permission) =>
    userPermissions.includes(permission)
  )

  if (!permission) return undefined

  return permission
}
